import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

type ModalType = {
    children: React.ReactNode;
    title: string;
    updateModalVisibility: () => void;
    isOpenModal: () => void;
};

const ModalSelector = ({
    children,
    title,
    updateModalVisibility,
    isOpenModal,
}: ModalType) => {
    const callFunctionsModal = () => {
        updateModalVisibility();
        isOpenModal();
    };
    return (
        <div className="c-modal">
            <header className="c-modal__title">
                <span className="c-modal_title c-modal__title--text">
                    {title}
                </span>
                <span className="c-modal__title--close">
                    <FontAwesomeIcon
                        icon={faTimes}
                        onClick={() => {
                            callFunctionsModal();
                        }}
                    />
                </span>
            </header>

            <main>{children}</main>
        </div>
    );
};

export default ModalSelector;
